import api from '../../plugins/api';

const pkbRequestConsent = ({ iin, phone, parentIin }) => {
  return api.post('/api/crm/clients/pkb/requestConsent', { iin, phone, parentIin });
};

export default pkbRequestConsent;
